export const snapshotAttachmentIds = attachments =>
  new Set((attachments || []).map(attachment => attachment.id));

const generationsByStore = new WeakMap();

export const DELAYED_ATTACHMENT_BUILD_MARKER =
  'shafra-chatwoot-delayed-attachment-generation-v3';

const generationsFor = state => {
  if (!state || typeof state !== 'object') {
    throw new TypeError(
      `${DELAYED_ATTACHMENT_BUILD_MARKER}: invalid Vuex conversation state`
    );
  }
  let generations = generationsByStore.get(state);
  if (!generations) {
    generations = new Map();
    generationsByStore.set(state, generations);
  }
  return generations;
};

export const beginAttachmentFetch = (state, conversationId) => {
  const generations = generationsFor(state);
  const generation = (generations.get(conversationId) || 0) + 1;
  generations.set(conversationId, generation);
  return generation;
};

export const isLatestAttachmentFetch = (state, conversationId, generation) =>
  generationsFor(state).get(conversationId) === generation;

export const mergeFetchedAttachments = ({ fetched, current, idsAtFetchStart }) => {
  const seen = new Set();
  const fetchedPage = (fetched || []).filter(attachment => {
    if (seen.has(attachment.id)) return false;
    seen.add(attachment.id);
    return true;
  });
  const concurrent = (current || []).filter(attachment => {
    if (idsAtFetchStart.has(attachment.id) || seen.has(attachment.id)) return false;
    seen.add(attachment.id);
    return true;
  });
  return [...fetchedPage, ...concurrent];
};
